import { type SearchQuotationResult } from "@repo/api";
import { assertUnreachable } from "@repo/utils";
import { type ActionType, createAction, getType } from "typesafe-actions";

export interface AddQuotationState {
  defaultPartyId?: string;
  customerInfo?: {
    id: string;
    name: string;
    email: string;
    isRegistered: boolean;
  };
  searchValue?: string;
  quotations?: SearchQuotationResult[];
  quotationNumbers?: string[];
}

export const AddQuotationStateDefault: AddQuotationState = {
  customerInfo: undefined,
  searchValue: undefined,
  quotationNumbers: undefined,
};

export type AddQuotationStateActions = typeof addQuotationStateActions;
export const addQuotationStateActions = {
  setCustomer:
    createAction("SET_CUSTOMER")<AddQuotationState["customerInfo"]>(),

  setQuotations:
    createAction("SET_QUOTATIONS")<AddQuotationState["quotations"]>(),
  setSearchValue: createAction("SET_SEARCH_VALUE")<string | undefined>(),
  setQuotationNumbers: createAction("SET_QUOTATION_NUMBERS")<
    AddQuotationState["quotationNumbers"]
  >(),
};

export function addQuotationStateReducer(
  state: AddQuotationState,
  action: ActionType<AddQuotationStateActions>
): AddQuotationState {
  switch (action.type) {
    case getType(addQuotationStateActions.setCustomer):
      return {
        ...state,
        customerInfo: action.payload,
        quotations: undefined,
      };

    case getType(addQuotationStateActions.setSearchValue):
      return {
        ...state,
        searchValue: action.payload,
        quotations: undefined,
      };
    case getType(addQuotationStateActions.setQuotations):
      return {
        ...state,
        searchValue: undefined,
        quotations: action.payload,
      };

    case getType(addQuotationStateActions.setQuotationNumbers):
      return {
        ...state,
        quotationNumbers: action.payload,
      };
  }
  assertUnreachable(action);
}
